import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import "../geometry.js";
import e from "../Viewpoint.js";
import i from "../core/Error.js";
import s from "../core/Logger.js";
import { isSome as n, isNone as a } from "../core/maybe.js";
import { throwIfAborted as r } from "../core/promiseUtils.js";
import { createScreenPoint as o } from "../core/screenUtils.js";
import { whenTrueOnce as l } from "../core/watchUtils.js";
import { property as p } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as h } from "../core/accessorSupport/decorators/subclass.js";
import { canProject as d, project as m } from "../geometry/support/webMercatorUtils.js";
import u from "../layers/support/TileInfo.js";
import { PopupView as c } from "./PopupView.js";
import g from "./View.js";
import y from "./ViewAnimation.js";
import f from "./2d/AnimationManager.js";
import w from "./2d/FrameTask.js";
import { layerView2DImporter as _ } from "./2d/layerViewModuleImportUtils.js";
import v from "./2d/MapViewConstraints.js";
import T from "./2d/PaddedViewState.js";
import "./2d/tiling/PagedTileQueue.js";
import z from "./2d/tiling/TileInfoView.js";
import "./2d/tiling/TileKey.js";
import "./2d/tiling/TileQueue.js";
import "./2d/tiling/TileStrategy.js";
import { centerAt as V, setExtent as S, rotateTo as x, scaleTo as R, copy as j, createAsync as b, resize as O, extentToScale as M } from "./2d/viewpointUtils.js";
import I from "./2d/layers/features/support/TileStore.js";
import { Timeline as k } from "./2d/support/Timeline.js";
import P from "../geometry/Point.js";
import G from "../geometry/Extent.js";
import E from "../geometry/SpatialReference.js";
var L = s.getLogger("esri.views.MapView");

function N(t) {
  return t && "esri.Viewpoint" === t.declaredClass;
}

var q = 160;

var A = /*#__PURE__*/function (_c) {
  _inherits(A, _c);

  var _super = _createSuper(A);

  function A(t) {
    var _this;

    _classCallCheck(this, A);

    _this = _super.call(this, t), _this._stationaryTimer = null, _this.frameTask = new w(_assertThisInitialized(_this)), _this.featuresTilingScheme = null, _this.fullOpacity = 1, _this.graphicsView = null, _this.initialExtent = null, _this.map = null, _this.labelManager = null, _this.renderingOptions = {
      samplingMode: "dynamic",
      edgeLabelsVisible: !0,
      labelsAnimationTime: 125,
      labelCollisionsEnabled: !0
    }, _this.resizeAlign = "center", _this.supportsGround = !1, _this.timeline = new k(), _this.type = "2d", _this.constraints = new v(), _this.padding = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };

    var e = _this.handles,
        i = function i() {
      return _this.notifyChange("updating");
    };

    e.add([_this.watch("viewpoint", function () {
      _this._lastStationaryEventTimestamp = performance.now(), _this._flipStationary(q);
    }, !0), _this.on("resize", function (t) {
      return _this._resizeHandler(t);
    }), _this.watch("animationManager.animation", function (t) {
      _this.animation = t;
    }), _this.allLayerViews.on("change", function () {
      i(), e.remove("map-view-base-layerViewsUpdating"), e.add(_this.allLayerViews.map(function (t) {
        return t.watch("updating", i);
      }), "map-view-base-layerViewsUpdating");
    })], "map-view-base");
    return _this;
  }

  _createClass(A, [{
    key: "destroy",
    value: function destroy() {
      this.destroyed || (this._set("preconditionsReady", !1), this._gotoTask = this.frameTask = null);
    }
  }, {
    key: "_defaultsFromMapSettings",
    get: function get() {
      return {
        required: {
          tileInfo: !0,
          heightModelInfo: !1,
          extent: !1
        }
      };
    }
  }, {
    key: "animation",
    set: function set(t) {
      var _this2 = this;

      var e = this._get("animation");

      if (t === e) return;
      if (e && e.stop(), !t || t.isFulfilled()) return void this._set("animation", null);
      this._set("animation", t), this.frameTask.animationInProgress = !0;

      var i = function i() {
        t === _this2._get("animation") && (_this2._set("animation", null), _this2.frameTask.requestFrame()), _this2.frameTask.animationInProgress = !1;
      };

      t.when(i, i);
    }
  }, {
    key: "center",
    get: function get() {
      if (!this.ready) return this._get("center");
      var _this$state$paddedVie = this.state.paddedViewState,
          t = _this$state$paddedVie.center,
          e = _this$state$paddedVie.spatialReference;
      return new P({
        x: t[0],
        y: t[1],
        spatialReference: e
      });
    },
    set: function set(t) {
      if (null == t) return;
      if (!this._normalizeInput(t)) return void L.error("#center", "incompatible spatialReference ".concat(JSON.stringify(t.spatialReference), " with view's spatialReference ").concat(JSON.stringify(this.spatialReference)));
      if (!this.ready) return this._set("center", t), void this.notifyChange("initialExtentRequired");
      var e = this.viewpoint;
      V(e, e, t), this.viewpoint = e;
    }
  }, {
    key: "constraints",
    set: function set(t) {
      var _this3 = this;

      var e = this._get("constraints");

      e && (this.handles.remove("map-view-base-constraints"), e.destroy()), this._set("constraints", t), t && (t.view = this, this.ready && (this.state.viewpoint = t.fit(this.state.paddedViewState.viewpoint)), this.handles.add(t.on("update", function () {
        _this3.ready && _this3.state && (_this3.state.viewpoint = t.fit(_this3.state.paddedViewState.viewpoint));
      }), "map-view-base-constraints"));
    }
  }, {
    key: "extent",
    get: function get() {
      return this.ready ? this.state.paddedViewState.extent.clone() : this._get("extent");
    },
    set: function set(t) {
      if (null == t) return;

      var e = this._normalizeInput(t);

      if (!e) return void L.error("#center", "incompatible spatialReference ".concat(JSON.stringify(t.spatialReference), " with view's spatialReference ").concat(JSON.stringify(this.spatialReference)));
      if (!e.width || !e.height) return void L.error("#extent", "invalid extent size");
      if (!this.ready) return this._set("extent", e), this._set("center", null), this._set("viewpoint", null), this._set("scale", 0), this._set("zoom", -1), void this.notifyChange("initialExtentRequired");
      var i = this.viewpoint;
      S(i, i, e, this.size, {
        constraints: this.constraints
      }), this.viewpoint = i;
    }
  }, {
    key: "graphicsTileStore",
    get: function get() {
      return new I(this.featuresTilingScheme);
    }
  }, {
    key: "initialExtentRequired",
    get: function get() {
      var t = this._normalizeInput(this.center),
          e = this._normalizeInput(this.viewpoint),
          i = this._normalizeInput(this.extent),
          s = this.scale,
          a = this.constraints;

      var r = this.zoom;
      return !this.get("map.initialViewProperties.viewpoint") && !i && (a.effectiveLODs || (r = -1), (!t || 0 === s && -1 === r) && (!e || !n(e.targetGeometry) || "extent" !== e.targetGeometry.type && !e.scale));
    }
  }, {
    key: "padding",
    get: function get() {
      return this.ready ? this.state.padding : this._get("padding");
    },
    set: function set(t) {
      this.ready ? (this.state.padding = t, this._set("padding", this.state.padding)) : this._set("padding", t);
    }
  }, {
    key: "resolution",
    get: function get() {
      return this.state ? this.state.resolution : 0;
    }
  }, {
    key: "rotation",
    get: function get() {
      return this.ready ? this.state.rotation : this._get("rotation");
    },
    set: function set(t) {
      if (isNaN(t)) return;
      if (!this.ready) return void this._set("rotation", t);
      var e = this.viewpoint;
      x(e, e, t), this.viewpoint = e;
    }
  }, {
    key: "scale",
    get: function get() {
      return this.ready ? this.state.scale : this._get("scale");
    },
    set: function set(t) {
      if (!t || isNaN(t)) return;

      if (!this.ready) {
        this._set("scale", t), this._set("zoom", -1);

        var _e = this._get("extent");

        return _e && (this._set("extent", null), this._set("center", _e.center)), void this.notifyChange("initialExtentRequired");
      }

      var e = this.viewpoint;
      R(e, e, t), this.viewpoint = e;
    }
  }, {
    key: "stationary",
    get: function get() {
      return !(this.animation || this.navigating || this._get("resizing") || this._stationaryTimer);
    }
  }, {
    key: "updating",
    get: function get() {
      return !this.destroyed && (!0 === this.get("layerViewManager.updating") || !0 === this.get("labelManager.updating") || !0 === this.get("graphicsView.updating") || this.allLayerViews.some(function (t) {
        return !t.destroyed && !("layerViews" in t) && !0 === t.updating;
      }));
    }
  }, {
    key: "viewpoint",
    get: function get() {
      if (!this.ready) return this._get("viewpoint");
      var t = this.state.paddedViewState;
      return t && t.viewpoint.clone();
    },
    set: function set(t) {
      if (null == t) return;

      var i = this._normalizeInput(t);

      if (!i) return void (!t.scale || isNaN(t.scale) ? L.error("#viewpoint", "invalid scale value of ".concat(t.scale)) : a(t.targetGeometry) ? L.error("#viewpoint", "geometry not defined") : L.error("#viewpoint", "incompatible spatialReference ".concat(JSON.stringify(t.targetGeometry.spatialReference), " with view's spatialReference ").concat(JSON.stringify(this.spatialReference))));
      if (!this.ready) return this._set("viewpoint", i), this._set("extent", null), this._set("center", null), this._set("zoom", -1), this._set("scale", 0), void this.notifyChange("initialExtentRequired");
      var s = new e({
        targetGeometry: new P(),
        scale: 0,
        rotation: 0
      });
      j(s, i), this.constraints.constrain(s, this.state.paddedViewState.viewpoint), this.state.viewpoint = s, this.frameTask.requestFrame(), this._set("viewpoint", s);
    }
  }, {
    key: "zoom",
    get: function get() {
      return this.ready ? this.constraints.scaleToZoom(this.scale) : this._get("zoom");
    },
    set: function set(t) {
      if (null == t) return;

      if (!this.ready) {
        this.notifyChange("initialExtentRequired"), this._set("zoom", t), this._set("scale", 0);

        var _e2 = this._get("extent");

        _e2 && (this._set("extent", null), this._set("center", _e2.center));
      }

      if (!this.constraints.effectiveLODs) return;
      var e = this.viewpoint;
      R(e, e, this.constraints.zoomToScale(t)), this.viewpoint = e, this._set("zoom", this.constraints.scaleToZoom(this.scale));
    }
  }, {
    key: "goTo",
    value: function goTo(t, e) {
      var _this4 = this;

      if (t) return this.animation && (this.animation = null), this._createAnimation(), l(this, "ready", e && e.signal).then(function () {
        var i = _objectSpread({
          animate: !0
        }, e),
            s = b(t, _this4);

        return _this4.animation.update(s), _this4._gotoTask = {}, i.animate ? _this4._gotoAnimated(s, i) : _this4._gotoImmediate(s, i);
      });
      L.error("#goTo()", "target cannot be null or undefined");
    }
  }, {
    key: "hitTest",
    value: function hitTest(t) {
      return Promise.reject("Should be implemented by subclasses");
    }
  }, {
    key: "popupHitTest",
    value: function popupHitTest(t) {
      var _this5 = this;

      return this.hitTest(t).then(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          mapPoint: _this5.toMap(t)
        });
      });
    }
  }, {
    key: "toMap",
    value: function toMap(t) {
      if (!this.ready) return null;

      var e = [0, 0],
          _this$state$toMap = this.state.toMap(e, [t.x, t.y]),
          _this$state$toMap2 = _slicedToArray(_this$state$toMap, 2),
          i = _this$state$toMap2[0],
          s = _this$state$toMap2[1],
          n = this.spatialReference;

      return new P({
        x: i,
        y: s,
        spatialReference: n
      });
    }
  }, {
    key: "toScreen",
    value: function toScreen(t) {
      if (!this.ready) return null;

      var e = this._normalizeInput(t),
          i = [e.x, e.y];

      return this.state.toScreen(i, i), o(i[0], i[1]);
    }
  }, {
    key: "pixelSizeAt",
    value: function pixelSizeAt() {
      return this.ready ? this.state.resolution : (L.error("#pixelSizeAt()", "Map view cannot be used before it is ready"), null);
    }
  }, {
    key: "requestUpdate",
    value: function requestUpdate() {
      this.ready && this.frameTask.requestUpdate();
    }
  }, {
    key: "getDefaultSpatialReference",
    value: function getDefaultSpatialReference() {
      var t, e, i;
      return this.map && "initialViewProperties" in this.map && (null == (t = this.map) || null == (e = t.initialViewProperties) ? void 0 : e.spatialReference) || (null == (i = this.defaultsFromMap) ? void 0 : i.spatialReference) || null;
    }
  }, {
    key: "getSpatialReferenceSupport",
    value: function getSpatialReferenceSupport(_ref) {
      var t = _ref.layer;
      return t || this._get("ready") || null !== this._getDefaultViewpoint() ? {} : null;
    }
  }, {
    key: "importLayerView",
    value: function importLayerView(t) {
      return _.importLayerView(t);
    }
  }, {
    key: "hasLayerViewModule",
    value: function hasLayerViewModule(t) {
      return _.hasLayerViewModule(t);
    }
  }, {
    key: "_createAnimation",
    value: function _createAnimation() {
      return this.animation && !this.animation.done || (this.animation = new y()), this.animation;
    }
  }, {
    key: "_cancellableGoTo",
    value: function _cancellableGoTo(t, e, i) {
      var _this6 = this;

      var s = function s() {
        return t === _this6._gotoTask;
      },
          n = i.then(function () {
        s() && (_this6.animation = null);
      }).catch(function (t) {
        throw s() && (_this6.animation = null, e.done || (e.stop(), _this6.frameTask.animationInProgress = !1)), t;
      }),
          a = new Promise(function (t) {
        return t(n);
      });

      return e.when().catch(function () {
        s() && a.cancel && a.cancel();
      }), a;
    }
  }, {
    key: "_gotoImmediate",
    value: function _gotoImmediate(t, e) {
      var _this7 = this;

      var s = this._gotoTask,
          n = this.animation,
          a = t.then(function (t) {
        if (r(e), s !== _this7._gotoTask) throw new i("view:goto-interrupted", "Goto was interrupted");
        _this7.viewpoint = n.target = t, n.finish();
      });
      return this._cancellableGoTo(s, n, a);
    }
  }, {
    key: "_gotoAnimated",
    value: function _gotoAnimated(t, e) {
      var _this8 = this;

      var s = this._gotoTask,
          n = this.animation,
          a = t.then(function (t) {
        if (r(e), s !== _this8._gotoTask) throw new i("view:goto-interrupted", "Goto was interrupted");
        return n.update(t), _this8.animationManager.animate(n, _this8.viewpoint, e), n.when().then(function () {}, function () {});
      });
      return this._cancellableGoTo(s, n, a);
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler(t) {
      var e = this.state;
      if (!e) return;
      var i = this.state.paddedViewState.viewpoint;
      var s = this.state.paddedViewState.size.concat();
      e.size = [t.width, t.height], O(i, i, s, this.state.paddedViewState.size, this.resizeAlign), i = this.constraints.constrain(i, null), this.state.viewpoint = i;
    }
  }, {
    key: "_startup",
    value: function _startup() {
      var t = this._getDefaultViewpoint();

      this.constraints.view = this, this.constraints.fit(t), this._set("animationManager", new f({
        view: this
      })), this._set("state", new T({
        padding: this._get("padding"),
        size: this.size,
        viewpoint: t
      })), this._set("featuresTilingScheme", new z(u.create({
        spatialReference: this.spatialReference,
        size: 512,
        numLODs: 36
      }))), this._set("ready", !0), this.frameTask && this.frameTask.start();
    }
  }, {
    key: "_teardown",
    value: function _teardown() {
      this.frameTask && this.frameTask.stop(), this._set("ready", !1), this._stationaryTimer && (clearTimeout(this._stationaryTimer), this._stationaryTimer = null);

      var _this$state$paddedVie2 = this.state.paddedViewState,
          _this$state$paddedVie3 = _slicedToArray(_this$state$paddedVie2.center, 2),
          t = _this$state$paddedVie3[0],
          e = _this$state$paddedVie3[1],
          i = _this$state$paddedVie2.spatialReference,
          s = _this$state$paddedVie2.rotation,
          n = _this$state$paddedVie2.scale,
          a = new P({
        x: t,
        y: e,
        spatialReference: i
      });

      this._set("viewpoint", null), this._set("extent", null), this._set("center", a), this._set("zoom", -1), this._set("rotation", s), this._set("scale", n), this._set("spatialReference", i), this.constraints.view = null, this.animationManager.destroy(), this._set("animationManager", null), this._set("state", null), this.animation = null;
    }
  }, {
    key: "_flipStationary",
    value: function _flipStationary(t) {
      var _this9 = this;

      return null !== this._stationaryTimer || (this._stationaryTimer = setTimeout(function () {
        _this9._stationaryTimer = null;

        var t = performance.now() - _this9._lastStationaryEventTimestamp;

        t < q && (_this9._stationaryTimer = _this9._flipStationary(t));
      }, t)), this._stationaryTimer;
    }
  }, {
    key: "_normalizeInput",
    value: function _normalizeInput(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.spatialReference;
      var i = t && t.targetGeometry || t;
      return e ? i ? e.equals(i.spatialReference) ? t : d(i, e) ? N(t) ? (t.targetGeometry = m(i, e), t) : m(i, e) : null : null : t;
    }
  }, {
    key: "_getDefaultViewpoint",
    value: function _getDefaultViewpoint() {
      var t = this.constraints,
          i = {
        zoom: this._get("zoom"),
        scale: this._get("scale"),
        center: this._normalizeInput(this._get("center")),
        extent: this._normalizeInput(this._get("extent")),
        rotation: this._get("rotation"),
        viewpoint: this._normalizeInput(this._get("viewpoint")),
        spatialReference: this._userSpatialReference
      };
      t.effectiveLODs ? -1 !== i.zoom && (i.scale = t.zoomToScale(i.zoom)) : i.zoom = -1;
      var s = null,
          a = null,
          r = 0;
      var o = i.viewpoint && i.viewpoint.rotation,
          l = i.viewpoint && i.viewpoint.targetGeometry;
      n(l) && ("extent" === l.type ? s = l : "point" === l.type && (a = l, r = i.viewpoint.scale));

      var p = this._normalizeInput(this.get("map.initialViewProperties.viewpoint.targetGeometry.extent")),
          h = this._normalizeInput(this.initialExtent),
          d = i.extent || s || p || h,
          m = i.center || a || d && d.center,
          u = this.get("map.initialViewProperties.viewpoint.scale"),
          c = i.scale || r || u || d && M(d, this.size),
          g = this.get("map.initialViewProperties.viewpoint.rotation"),
          y = i.rotation || o || g || 0;

      return m && c ? new e({
        targetGeometry: m,
        scale: c,
        rotation: y
      }) : null;
    }
  }]);

  return A;
}(c(g));

t([p()], A.prototype, "_stationaryTimer", void 0), t([p()], A.prototype, "_defaultsFromMapSettings", null), t([p()], A.prototype, "animation", null), t([p({
  readOnly: !0
})], A.prototype, "animationManager", void 0), t([p({
  value: null,
  type: P,
  dependsOn: ["state.id", "ready"]
})], A.prototype, "center", null), t([p({
  type: v
})], A.prototype, "constraints", null), t([p({
  value: null,
  type: G,
  dependsOn: ["state.id", "ready"]
})], A.prototype, "extent", null), t([p({
  readOnly: !0
})], A.prototype, "featuresTilingScheme", void 0), t([p()], A.prototype, "fullOpacity", void 0), t([p({
  readOnly: !0
})], A.prototype, "graphicsTileStore", null), t([p()], A.prototype, "graphicsView", void 0), t([p({
  type: G
})], A.prototype, "initialExtent", void 0), t([p({
  dependsOn: ["map.initialViewProperties?.viewpoint", "constraints.effectiveLODs", "spatialReference"]
})], A.prototype, "initialExtentRequired", null), t([p()], A.prototype, "map", void 0), t([p()], A.prototype, "labelManager", void 0), t([p({
  value: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  cast: function cast(t) {
    return _objectSpread({
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, t);
  }
})], A.prototype, "padding", null), t([p({
  type: Object
})], A.prototype, "renderingOptions", void 0), t([p()], A.prototype, "resizeAlign", void 0), t([p({
  readOnly: !0,
  dependsOn: ["state.id"]
})], A.prototype, "resolution", null), t([p({
  value: 0,
  type: Number,
  dependsOn: ["state.id", "ready"]
})], A.prototype, "rotation", null), t([p({
  value: 0,
  type: Number,
  dependsOn: ["state.id", "ready"]
})], A.prototype, "scale", null), t([p({
  type: E,
  dependsOn: ["map.initialViewProperties?.spatialReference", "defaultsFromMap.ready"]
})], A.prototype, "spatialReference", void 0), t([p({
  readOnly: !0
})], A.prototype, "state", void 0), t([p({
  dependsOn: ["animation", "navigating", "resizing", "_stationaryTimer"]
})], A.prototype, "stationary", null), t([p({
  readOnly: !0
})], A.prototype, "supportsGround", void 0), t([p({
  type: k,
  readOnly: !0
})], A.prototype, "timeline", void 0), t([p({
  readOnly: !0
})], A.prototype, "type", void 0), t([p({
  readOnly: !0,
  dependsOn: ["layerViewManager.updating", "labelManager.updating", "graphicsView?.updating"]
})], A.prototype, "updating", null), t([p({
  value: null,
  type: e,
  dependsOn: ["state.id", "ready"]
})], A.prototype, "viewpoint", null), t([p({
  value: -1,
  dependsOn: ["state.id"]
})], A.prototype, "zoom", null), A = t([h("esri.views.MapViewBase")], A);
var U = A;
export { U as default };